import { render, staticRenderFns } from "./details.vue?vue&type=template&id=c43ebc06&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=c43ebc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43ebc06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c43ebc06')) {
      api.createRecord('c43ebc06', component.options)
    } else {
      api.reload('c43ebc06', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=c43ebc06&scoped=true&", function () {
      api.rerender('c43ebc06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerMappingDraft/components/details.vue"
export default component.exports